//#region IMPORTS
import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import ImageCrop from '../../components/HelperComponents/ImageCrop/ImageCrop.tsx'
import { formatAddress } from '../../components/HelperComponents/AddressFormatter'
import { DateFormatter } from '../../components/HelperComponents/DateFormatter.ts'
import URL from '../../Constants/URL.js'
import { GetStatusName, GetStatusVm } from '../../components/HelperComponents/StatusHelper';
import { GetCprStatusName, IsCprStatusValidForDriverCards, GetCprStatusKode, IsCprStatusValidForDriverCardToEkspeditionssted } from '../../components/HelperComponents/CprStatusHelper';
import { checkIfCardExpired, checkIfCardExpiresWitihinTwoMonths } from '../../components/HelperComponents/ValidityDateHelpers';
import { nameTooLong, sortCardTableByCreatedDate, getEkspeditionsType, localDateToUtcDate } from '../../components/HelperComponents/Helpers';
import { filterCardStatusesRenewed, filterCardStatusesReplaced } from '../../components/HelperComponents/FilterCardStatuses.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { CprToDateOfBirth } from '../../components/HelperComponents/CprToDateOfBirth.ts'
import { DriverCardVm } from '../../Models/DriverCardVm';
import { PersonVm } from '../../Models/PersonVm';
import { CheckIssuedCardsVm } from '../../Models/CheckIssuedCardsVm';
import { ValidationType } from '../../Constants/ValidationTypes.ts';
import { CardOrderDriverCard } from '../../Models/CardOrderDriverCard'
import { DriverLicenseVm } from '../../Models/DriverLicenseVm';
import { CountryCodeVm } from '../../Models/CountryCodeVm';

//#endregion

//#region CLASS/CONSTRUCTOR/STATE
export default function CreateDriverCard() {
  return <CreateClass />
}

class CreateClass extends Component {
  static displayName = CreateClass.name;

  temporaryDriverLicenseInputs = {
    driversLicenseIssuingAuthority: "Færdselsstyrelsen",
    remark: "Midlertidigt kørekort forevist.",
  }

  driversLicenseTypes = {
    permanent: "permanent",
    unvalidated: "unvalidated",
    temporary: "temporary",
    international: "international"
  }

  orderTypes = {
    nyudstedelse: "Nyudstedelse",
    fornyelse: "Fornyelse",
    erstatning: "Erstatning",
    udskiftning: "Udskiftning"
  }

  amountOfCards = 1;

  constructor(props) {
    super(props);
    this.toast = React.createRef();

    this.state = {
      countries: [{ CountryName: "Denmark", IsoCode: "DK" }],

      countryInput: "Denmark",
      countryISO: "DK",
      cprInput: "",

      driversLicenseType: this.driversLicenseTypes.permanent,
      driverLicenseNumber: "",
      driversLicenseIssuingAuthority: "",
      remark: "",
      firstNameOnCard: "",
      lastNameOnCard: "",

      validTo: null,
      validFrom: null,

      orderType: this.orderTypes.nyudstedelse,
      previousCardStatus: "",

      //ButtonPressChecks
      cprButtonPressed: false,
      driverLicenceButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      cprIsValid: false,
      driverLicenseNumberIsValid: false,
      driversLicenseAuthorityIsValid: false,
      driverLicenseRemarkIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,

      fileBase64: "", // the picture
      pictureChosen: false,
      pictureTooBig: false,
      showImageCropper: false,

      expressDelivery: false,
      deliveryToPlaceOfDispatch: false,
      deliveryToPlaceOfDispatchRequired: false,
      placeOfDispatch: "",


      personVm: new PersonVm(),
      driverLicenseVm: [new DriverLicenseVm()],

      //Show/Hide elements
      openModal: false,
      openResperErrorModal: false,
      showSpinner: false,
      showDriverLicenseSpinner: false,

      //Search results
      mostRecentCard: null,
      dkTableResults: [],
      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      },
    };
  }

  componentDidMount() {
    this.setValidityPeriod()
    this.fetchCountries()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.orderType !== this.state.orderType || prevState.mostRecentCard !== this.state.mostRecentCard) {
      this.setValidityPeriod()
      if (prevState.mostRecentCard !== this.state.mostRecentCard) {
        this.setState({ orderType: this.getRadiobuttons()[0] })
      }
    }
    if (prevState.personVm !== this.state.personVm) {
      this.setNameOnCard(this.state.personVm)
    }
  }

  //#endregion

  //#region API CALLS

  fetchCountries() {
    var dk = new CountryCodeVm()
    dk.CountryName = "Denmark"
    dk.IsoCode = "DK"
    var res = [dk]
    fetchModel("GET", URL + "/api/search/GetLandeKoder", "", CountryCodeVm)
      .then(model => {
        res = model
      })
      .catch(() => {
        this.showErrorToast("Fejl", "Udstedende lande kunne ikke hentes")
      })
      .finally(() => {
        this.setState({ countries: res })
      })
  }


  cprSearch() {
    this.setState({ cprButtonPressed: true })
    this.clearOnCprSearch()
    if (this.state.cprIsValid) {
      this.setState({ showSpinner: true })
      this.fetchPersonInfo()
      this.fetchDriverCards()
    }
  }

  fetchDriverCards() {
    fetchModel("GET", URL + "/api/drivercard/GetDriverCardsByCpr", this.state.cprInput, DriverCardVm)
      .then(model => {
        this.handleDkSearchResults(model);
      })
      .catch((error) => {
        if (error !== "No result") {
          this.showErrorToast(error, "")
        }
      })
      .finally(() => this.setState({ showSpinner: false }))
  }

  fetchPersonInfo() {
    fetchModel("GET", URL + "/api/search/GetPerson", this.state.cprInput, PersonVm)
      .then(model => {
        if (model[0].Cpr) {
          this.fetchDriverCardsFromEU(model[0])
          this.setState({ personVm: model[0] },
            () => this.handleCprStatus()
          )
          if (!this.isPerson17(model[0])) {
            this.toast.current.show("Aldersgrænse", "Der må ikke oprettes førerkort til personer under 17 år.", "warning")
          }
        }
        else {
          this.showErrorToast("No result", "en person")
        }
      })
      .catch((error) => {
        this.showErrorToast(error, "en person")
      })
      .finally(() => {
        this.setState({ showSpinner: false })
      })
  }

  fetchDriverCardsFromEU(person) {
    this.setState({ showSpinner: true })
    fetchModel("GET", URL + "/api/drivercard/GetDriverCardsFromEuPerson/?firstname=" + person.FirstName +
      "&lastname=" + person.LastName +
      "&birthdate=" + CprToDateOfBirth(person.Cpr), "", CheckIssuedCardsVm)
      .then((model) => {
        if (model) {
          this.handleEuSearchResults(model[0])
        }
        this.setState({ showSpinner: false })
      }).catch(error => {
        this.showErrorToastEU(error)
        this.setState({ showSpinner: false })
      });
  }

  fetchDriverLicense() {
    this.setState({ driverLicenceButtonPressed: true })
    if (this.state.driverLicenseNumberIsValid) {
      this.clearOnDriverLicenseSearch()
      this.setState({ showDriverLicenseSpinner: true })
      fetchModel("GET", URL + "/api/search/GetDrivingLicense", this.state.driverLicenseNumber, DriverLicenseVm)
        .then(model => {
          this.handleDriverLicenseResults(model)
          if (this.state.driversLicenseType === this.driversLicenseTypes.temporary) {
            if (model[0].ResponseStatus === "Found") {
              this.toast.current.show("Fejl", "Der findes allerede et permanent kørekort med det søgte Kørekortnummer.", "warning")
            }
          }
        })
        .catch(error => {
          this.showErrorToast("driverLicenseError", "Kunne ikke oprette forbindelse til kørekortregistret")
        })
        .finally(() => this.setState({ showDriverLicenseSpinner: false }))
    }
  }

  handleDriverLicenseResults(model) {
    this.setState({ driverLicenseVm: model })
    if (model[0].ResponseStatus === "Found") {
      return
    }

    if (model[0].ResponseStatus === "NotFound") {
      if (this.state.driversLicenseType === this.driversLicenseTypes.temporary) {
        return
      }
      this.toast.current.show("Intet Resultat", "Der blev ikke fundet nogen oplysninger på kørekortnummeret", "warning")
    } else if (model[0].ResponseStatus === "NotAvailable") {
      this.toast.current.show("Ikke tilgængelig", "Oplysningerne er ikke tilgængelige", "warning")
    } else if (model[0].ResponseStatus === "Timeout") {
      this.toast.current.show("Timeout", "Resper svarede ikke.", "warning")
    }
    this.setState({ openResperErrorModal: true })
  }

  fetchCreateCard() {
    var model = new CardOrderDriverCard()
    model.KortType = "F";
    model.OrdreType = this.state.expressDelivery ? "1" : "0";
    model.SendTilEkspeditionssted = this.state.deliveryToPlaceOfDispatch;

    model.GebyrFrit = false;
    model.UdstedelsesDato = new Date();
    model.EkspeditionsType = getEkspeditionsType(this.state.orderType);

    model.KortBrugerFornavn = this.state.firstNameOnCard
    model.KortBrugerEfternavn = this.state.lastNameOnCard

    model.FoedselsDato = CprToDateOfBirth(this.state.personVm.Cpr);
    model.PostAdresseNavn = this.state.personVm.Address.Name;
    model.PostAdresseVejOgNr = this.state.personVm.Address.StreetNameAndNumber;
    model.PostAdresseStedNavn = this.state.personVm.Address.PlaceName;
    model.PostAdressePostNr = this.state.personVm.Address.PostalCode;
    model.PostAdressePostDistrikt = this.state.personVm.Address.City;

    model.GyldighedStartDato = localDateToUtcDate(this.state.validFrom);
    model.UdloebsDato = localDateToUtcDate(this.state.validTo);

    if (this.state.orderType === this.orderTypes.nyudstedelse) {
      model.KortNrTidligereKort = null;
    }
    else {
      model.KortNrTidligereKort = this.state.mostRecentCard.CardNumber;
    }

    model.UdstedendeMyndighed = this.state.deliveryToPlaceOfDispatch ? this.state.placeOfDispatch.substring(0, 4) : "2001";
    model.PersonNr = this.state.personVm.Cpr;
    model.KoerekortNr = this.state.driverLicenseNumber;
    model.KoereKortNationalitet = this.state.countryISO;
    model.KoerekortUdstedendeMyndighed = this.state.driversLicenseType === this.driversLicenseTypes.permanent ?
      this.state.driverLicenseVm[0].IssuingAuthority :
      this.state.driversLicenseIssuingAuthority;
    model.Antal = this.amountOfCards.toString();
    model.Malfunctioning = false;
    model.FotoData = this.state.fileBase64;
    model.IsAndenGeneration = "true";
    fetch(URL + "/api/drivercard/createOrder/", {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(model)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.valid) {
          if (this.state.orderType !== this.orderTypes.nyudstedelse) { this.setStatusOfPreviousCard() }
          this.clearPage()
          this.showSuccessToast()
          this.setState({ openModal: false })
        }
        else if (result.errors.length > 0) {
          this.showErrorToast(result.errors[0].exception, result.errors[0].message)
        }
        else
          this.showErrorToast("error", "")

      })
      .catch(error => console.error(error));
  }


  setStatusOfPreviousCard() {
    let model = this.state.mostRecentCard;
    model.Status = GetStatusVm(this.state.previousCardStatus)
    model.Remark = "Status ændret i forbindelse med oprettelse af nyt kort.";

    let success = true;
    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }
    fetch(URL + "/api/drivercard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
      })
      .catch(() => {
        success = false;
      })
      .finally(
        () => { if (!success) this.toast.current.show("Fejl", `Status på tidligere kort (${model.CardNumber}) blev ikke opdateret.`, "error") }
      )
  }

  handleCprStatus() {
    if (!IsCprStatusValidForDriverCards(this.state.personVm.CprStatus)) {
      if (!IsCprStatusValidForDriverCardToEkspeditionssted(this.state.personVm.CprStatus)) {
        this.toast.current.show("CPR Status", `Personer med status ${GetCprStatusKode(this.state.personVm.CprStatus)} kan ikke bestille kort.`, "warning")
      }
    }
    else if (IsCprStatusValidForDriverCardToEkspeditionssted(this.state.personVm.CprStatus)) {
      this.toast.current.show("CPR Status", `Personer med status ${GetCprStatusKode(this.state.personVm.CprStatus)} kan kun bestille kort til ekspeditionssted.`, "warning")
      var addressVm = {
        Name: "Ukendt adresseringsnavn",
        StreetNameAndNumber: `Ukendt adresse CPR status ${GetCprStatusKode(this.state.personVm.CprStatus)}`,
        PlaceName: "Ukendt adresse",
        PostalCode: "9999",
        City: "Ukendt adresse",
      }
      var personVm = this.state.personVm
      personVm.Address = addressVm
      this.setState({ deliveryToPlaceOfDispatchRequired: true, deliveryToPlaceOfDispatch: true, personVm: personVm })
    }
  }

  //#endregion 

  setImageBase64(base64) {
    if (new Blob([base64]).size > 1.99e+6) { // Antal bytes svarende til 1.99 MB
      base64 = null
      this.toast.current.show("Advarsel", `Billedet er for stort, prøv at beskære det anderledes.`, "warning")
      this.setState({ pictureTooBig: true })
    } else {
      this.setState({ pictureTooBig: false })
    }
    this.setImageValues(base64);
  }

  setImageValues(value) {
    if (value) {
      this.setState({ fileBase64: value, pictureChosen: true })
    }
    else {
      this.setState({ fileBase64: "", pictureChosen: false })
    }
  }

  isPerson17(personVm) {
    var today = new Date()
    var birthday = new Date(CprToDateOfBirth(personVm.Cpr))
    var years = new Date(today - birthday).getFullYear() - 1970;
    return years >= 17
  }

  isPersonVmValid() {
    let personVm = this.state.personVm
    let checkOk = personVm.Cpr
      && personVm.FirstName
      && personVm.LastName
      && (IsCprStatusValidForDriverCards(personVm.CprStatus))
    if (checkOk && !this.isPerson17(personVm)) {
      checkOk = false
      this.toast.current.show("Aldersgrænse", "Der må ikke oprettes førerkort til personer under 17 år.", "error")
    }
    return checkOk
  }

  isDriversLicenseValid() {
    let checkOk = this.state.driverLicenseNumberIsValid
    if (this.state.driversLicenseType === this.driversLicenseTypes.temporary) {
      checkOk = checkOk
        && this.state.driversLicenseAuthorityIsValid
        && this.state.driverLicenseRemarkIsValid
        && this.state.driverLicenseVm[0].ResponseStatus === "NotFound"
    }
    else if (this.state.driversLicenseType === this.driversLicenseTypes.permanent) {
      checkOk = checkOk
        && this.state.driverLicenseVm[0].IssuingAuthority !== ""
        && this.state.driverLicenseVm[0].BStatus === "Valid"
        && this.state.driverLicenseVm[0].Categories.includes("B")
    }
    else if (this.state.driversLicenseType === this.driversLicenseTypes.international) {
      checkOk = checkOk
        && this.state.driversLicenseAuthorityIsValid
        && this.state.driverLicenseRemarkIsValid
    } else if (this.state.driversLicenseType === this.driversLicenseTypes.unvalidated) {
      checkOk = checkOk
        && this.state.driversLicenseAuthorityIsValid
    }
    else {
      this.toast.current.show("Kørekortoplysninger", "Der er sket en uventet fejl i behandling af kørekortoplysninger", "error")
      checkOk = false
    }

    return checkOk
  }

  isPreviousCardStatusValid() {
    var ordertypesWithStatusChange = [this.orderTypes.erstatning, this.orderTypes.fornyelse, this.orderTypes.udskiftning]
    if (ordertypesWithStatusChange.includes(this.state.orderType)) {
      return this.state.previousCardStatus.length > 0
    }
    return true
  }


  validateOrder() {
    this.setState({ orderButtonPressed: true })

    let orderIsValid = true;
    let errorMessage = [];

    if (!this.isPersonVmValid()) {
      errorMessage.push("gyldige personoplysninger")
      orderIsValid = false;
    }
    if (!this.isDriversLicenseValid()) {
      errorMessage.push("kørekortoplysninger")
      orderIsValid = false;
    }
    if (!this.state.pictureChosen) {
      errorMessage.push("billede")
      orderIsValid = false;
    }
    if (!this.isPreviousCardStatusValid()) {
      errorMessage.push("status på tidligere kort")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.personVm.FirstName) && !this.state.firstNameOnCardIsValid) {
      errorMessage.push("gyldigt fornavn")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.personVm.LastName) && !this.state.lastNameOnCardIsValid) {
      errorMessage.push("gyldigt efternavn")
      orderIsValid = false;
    }
    if ((this.state.deliveryToPlaceOfDispatch || this.state.deliveryToPlaceOfDispatchRequired) && this.state.placeOfDispatch === "") {
      errorMessage.push("Lokation")
      orderIsValid = false;
    }

    if (orderIsValid) {
      this.setState({ openModal: true })
    } else {
      this.showValidationErrorToast(errorMessage)
    }
  }

  showValidationErrorToast(errorMessage) {
    errorMessage[0] = errorMessage[0].charAt(0).toUpperCase() + errorMessage[0].slice(1);
    var errorString = errorMessage.reduce(function (p, d, i) {
      return p + (i === errorMessage.length - 1 ? ' og ' : ', ') + d;
    });
    errorString += " mangler."
    this.toast.current.show("Se bestilling", errorString, "error")
  }

  //#region API RESPONSE MAPPING  

  handleDkSearchResults(result) {
    let results = []
      result = sortCardTableByCreatedDate(result);
    for (let i = 0; i < result.length; i++) {
      results.push([
        result[i].CardNumber,
        result[i].Person.DriverLicense.Number,
        DateFormatter(result[i].ValidFrom.split(" ")[0]),
        DateFormatter(result[i].ValidTo.split(" ")[0]),
        GetStatusName(result[i].Status.Id),
        result[i].Remark
      ])
    }
    this.setState({
      mostRecentCard: result[0],
      dkTableResults: results
    })

  }

  handleEuSearchResults(result) {
    let euAnswers = this.state.euAnswers;
    let results = []
    euAnswers.NotFound = 0
    euAnswers.NotAvailable = 0
    euAnswers.Found = 0
    euAnswers.TimeOut = 0

    for (let i = 0; i < result.MemberStates.length; i++) {
      if (result.MemberStates[i].statusCode === "Found") {
        euAnswers.Found += 1
      }
      else if (result.MemberStates[i].statusCode === "NotFound") {
        euAnswers.NotFound += 1
      }
      else if (result.MemberStates[i].statusCode === "Timeout") {
        euAnswers.TimeOut += 1
      }
      else if (result.MemberStates[i].statusCode === "NotAvailable") {
        euAnswers.NotAvailable += 1
      }

      for (let j = 0; j < result.MemberStates[i].checkIssuedCardResultVm.length; j++) {
        results.push([
          result.MemberStates[i].checkIssuedCardResultVm[j].cardNumber,
          result.MemberStates[i].checkIssuedCardResultVm[j].firstName,
          result.MemberStates[i].checkIssuedCardResultVm[j].lastName,
          result.MemberStates[i].memberStateCode,
          result.MemberStates[i].checkIssuedCardResultVm[j].driverLicenseNumber,
          result.MemberStates[i].checkIssuedCardResultVm[j].cardFromDate.split(" ")[0].replaceAll("/", "-"),
          result.MemberStates[i].checkIssuedCardResultVm[j].cardToDate.split(" ")[0].replaceAll("/", "-"),
          GetStatusName(result.MemberStates[i].checkIssuedCardResultVm[j].cardStatus),
        ])
      }
    }

    this.setState({
      euTableResults: results,
      euAnswers: euAnswers
    })
  }

  setCountryDropdown(country) {
    if (country !== "Denmark") {
      this.setState({
        driversLicenseType: this.driversLicenseTypes.international,
        driversLicenseIssuingAuthority: "",
        countryInput: country,
        countryISO: this.state.countries.find(c => c.CountryName === country).IsoCode,
        remark: "Udenlandsk kørekort."
      })
    }
    else {
      this.setState({
        driversLicenseType: this.driversLicenseTypes.permanent,
        countryInput: country,
        countryISO: "DK",
        driversLicenseIssuingAuthority: "",
        driverLicenseNumber: "",
        remark: ""
      })
    }
  }

  //#endregion

  //#region GUI EVENTS HANDLING

  clearOnCprSearch() {
    let keepDriversLicenceInfo = this.state.driversLicenseType === this.driversLicenseTypes.international

    this.setState({

      countryInput: keepDriversLicenceInfo ? this.state.countryInput : "Denmark",
      countryISO: keepDriversLicenceInfo ? this.state.countryISO : "DK",
      //cprInput: "",
      driversLicenseType: keepDriversLicenceInfo ? this.state.driversLicenseType : this.driversLicenseTypes.permanent,
      driverLicenseNumber: keepDriversLicenceInfo ? this.state.driverLicenseNumber : "",
      driversLicenseIssuingAuthority: keepDriversLicenceInfo ? this.state.driversLicenseIssuingAuthority : "",
      remark: keepDriversLicenceInfo ? this.state.remark : "",

      previousCardStatus: "",
      orderType: this.orderTypes.nyudstedelse,

      //ButtonPressChecks
      //cprButtonPressed: false,
      driverLicenceButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      //cprIsValid: false,
      driverLicenseNumberIsValid: keepDriversLicenceInfo ? this.state.driverLicenseNumberIsValid : false,
      driversLicenseAuthorityIsValid: keepDriversLicenceInfo ? this.state.driversLicenseAuthorityIsValid : false,
      driverLicenseRemarkIsValid: keepDriversLicenceInfo ? this.state.driverLicenseRemarkIsValid : false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,

      fileBase64: "", // the picture
      pictureChosen: false,
      pictureTooBig: false,
      showImageCropper: false,

      expressDelivery: false,
      deliveryToPlaceOfDispatch: false,
      deliveryToPlaceOfDispatchRequired: false,
      placeOfDispatch: "",

      personVm: new PersonVm(),
      driverLicenseVm: [new DriverLicenseVm()],

      //Show/Hide elements
      openModal: false,
      openResperErrorModal: false,
      showSpinner: false,
      showDriverLicenseSpinner: false,

      //Search results
      mostRecentCard: null,
      dkTableResults: [],
      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      },

    })
  }

  clearOnDriverLicenseSearch() {
    if (this.state.driversLicenseType === this.driversLicenseTypes.permanent) {
      this.setState({
        driverLicenseVm: [new DriverLicenseVm()],
        driversLicenseIssuingAuthority: "",
        remark: ""
      })
    }
    else if (this.state.driversLicenseType === this.driversLicenseTypes.temporary) {
      this.setState({
        driverLicenseVm: [new DriverLicenseVm()],
        driversLicenseIssuingAuthority: this.temporaryDriverLicenseInputs.driversLicenseIssuingAuthority,
        remark: this.temporaryDriverLicenseInputs.remark
      })
    }
  }


  clearPage() {

    this.setState({
      //countries: [],

      countryInput: "Denmark",
      countryIsoTemp: "DK",
      cprInput: "",
      driversLicenseType: this.driversLicenseTypes.permanent,
      driverLicenseNumber: "",
      driversLicenseIssuingAuthority: "",
      remark: "",
      firstNameOnCard: "",
      lastNameOnCard: "",

      previousCardStatus: "",
      orderType: this.orderTypes.nyudstedelse,

      //ButtonPressChecks
      cprButtonPressed: false,
      driverLicenceButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      cprIsValid: false,
      driverLicenseNumberIsValid: false,
      driversLicenseAuthorityIsValid: false,
      driverLicenseRemarkIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,

      fileBase64: "", // the picture
      pictureChosen: false,
      pictureTooBig: false,
      showImageCropper: false,

      expressDelivery: false,
      deliveryToPlaceOfDispatch: false,
      deliveryToPlaceOfDispatchRequired: false,
      placeOfDispatch: "",

      personVm: new PersonVm(),
      driverLicenseVm: [new DriverLicenseVm()],

      //Show/Hide elements
      openModal: false,
      openResperErrorModal: false,
      showSpinner: false,
      showDriverLicenseSpinner: false,

      //Search results
      mostRecentCard: null,
      dkTableResults: [],
      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      },

    })
  }

  showSuccessToast() {
    this.toast.current.show("Success", "Din bestilling er oprettet. ", "success")
  }

  showErrorToast(error, toastMessage) {
    this.setState({ showSpinner: false, showDriverLicenseSpinner: false })
    if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else if (error === "No result" && toastMessage) {
      this.toast.current.show("Fejl", `Der findes ikke ${toastMessage} med det søgte nummer`, "warning")
    }
    else if (error === "driverLicenseError" || error === "landekodeError") {
      this.toast.current.show("Fejl", toastMessage, "error")
    }
    else {
      this.toast.current.show("Fejl", `Der skete en ukendt fejl:${error} : ${toastMessage}`, "error")
    }
  }

  showErrorToastEU(error) {
    this.setState({ showSpinner: false })
    if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke hente data fra EU, prøv at søge igen om lidt.", "warning")
    }
    else {
      this.toast.current.show("EU resultater", "Der er sket en fejl: " + error, "error")
    }
  }

  showInputErrorToast(info) {
    this.setState({ showSpinner: false })
    this.toast.current.show("Førerkort", info, "error")
  }

  showCprStatusWarning() {
    return this.state.orderButtonPressed
      && !IsCprStatusValidForDriverCards(this.state.personVm.CprStatus)
  }

  setShowImageCropper(showCropper) {
    this.setState({ showImageCropper: showCropper })
  }

  getRadiobuttons() {
    if (this.state.mostRecentCard) {
      if (checkIfCardExpired(this.state.mostRecentCard)) {
        return [this.orderTypes.fornyelse]
      }
      else if (checkIfCardExpiresWitihinTwoMonths(this.state.mostRecentCard)) {
        return [this.orderTypes.fornyelse, this.orderTypes.erstatning, this.orderTypes.udskiftning]
      }
      else {
        return [this.orderTypes.erstatning, this.orderTypes.udskiftning]
      }
    }
    return [this.orderTypes.nyudstedelse]
  }

  setValidityPeriod() {
    let newValidFrom = null
    let newValidTo = null
    switch (this.state.orderType) {
      case this.orderTypes.nyudstedelse:
        newValidFrom = new Date()
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case this.orderTypes.fornyelse:
        if (checkIfCardExpired(this.state.mostRecentCard)) {
          newValidFrom = new Date()
        } else {
          newValidFrom = new Date(this.state.mostRecentCard.ValidTo)
          newValidFrom.setDate(newValidFrom.getDate() + 1)
        }
        newValidTo = new Date(newValidFrom)
        newValidTo.setFullYear(newValidFrom.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case this.orderTypes.erstatning:
        newValidFrom = new Date(Math.max(new Date(), new Date(this.state.mostRecentCard.ValidFrom)))
        newValidTo = new Date(this.state.mostRecentCard.ValidTo)
        break;
      case this.orderTypes.udskiftning:
        newValidFrom = new Date(Math.max(new Date(), new Date(this.state.mostRecentCard.ValidFrom)))
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      default:
    }

    this.setState({ validFrom: newValidFrom, validTo: newValidTo })
  }

  setNameOnCard(person) {
    this.setState({ firstNameOnCard: person.FirstName, lastNameOnCard: person.LastName })
  }

  handleTemporaryDriversLicenseCheckbox(isChecked) {
    this.setState({
      driverLicenseNumber: "",
      driverLicenseVm: [new DriverLicenseVm()],
    })
    if (isChecked) {
      this.setState({
        driversLicenseType: this.driversLicenseTypes.temporary,
        driversLicenseIssuingAuthority: this.temporaryDriverLicenseInputs.driversLicenseIssuingAuthority,
        remark: this.temporaryDriverLicenseInputs.remark
      })
    }
    else {
      this.setState({
        driversLicenseType: this.driversLicenseTypes.permanent,
        driversLicenseIssuingAuthority: ""
      })
      this.setState({ remark: "" })
    }
  }

  setDriverLicenseTypeToUnvalidated() {
    this.setState({
      openResperErrorModal: false,
      driversLicenseType: this.driversLicenseTypes.unvalidated,
      driverLicenseVm: [new DriverLicenseVm()],
      driversLicenseAuthorityIsValid: true
    })

  }

  //#endregion

  //#region GUI/RENDER

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toast} />

        <Fstyr.Modal
          show={this.state.openResperErrorModal}
          onDecline={() => { this.setState({ openResperErrorModal: false }) }}
          onAccept={() => { this.setDriverLicenseTypeToUnvalidated() }}
          label="Resper timeout."
          buttonGroupLabel="Bestil førerkort"
          buttonAcceptLabel="Fortsæt uden validering"
          buttonDeclineLabel="Annullér"
        />

        <Fstyr.Modal
          show={this.state.openModal}
          onDecline={() => { this.setState({ openModal: false }) }}
          onAccept={() => { this.fetchCreateCard() }}
          label="Bestil førerkort"
          buttonGroupLabel="Bestil førerkort"
          buttonAcceptLabel="Bestil"
          buttonDeclineLabel="Annullér"
          layout={[
            {
              "label": "Personlige informationer",
              "inputs": [
                { "label": "Land", "value": `${this.state.countryInput} (${this.state.countryISO})` },
                { "label": "Cpr-nummer", "value": this.state.personVm.Cpr },
                { "label": "Fornavn", "value": this.state.firstNameOnCard },
                { "label": "Efternavn", "value": this.state.lastNameOnCard },
                { "label": "Adresse ", "value": formatAddress(this.state.personVm.Address, true) }
              ]
            },
            {
              "label": "Kørekort informationer",
              "inputs": [
                { "label": "Kørekort nr.", "value": this.state.driverLicenseNumber },
                {
                  "label": "Udstedende myndighed", "value": this.state.driversLicenseType === this.driversLicenseTypes.permanent ?
                    this.state.driverLicenseVm[0].IssuingAuthority :
                    this.state.driversLicenseIssuingAuthority
                }
              ]
            },
            {
              "label": "Bestillingsinformationer",
              "inputs": [
                { "label": "Type", "value": this.state.orderType },
                { "label": "Gyldighedsperiode", "value": DateFormatter(this.state.validFrom) + " til " + DateFormatter(this.state.validTo) },
                { "label": "Antal kort", "value": this.amountOfCards },
                { "label": "Ekspreslevering", "value": this.state.expressDelivery ? "Ja" : "Nej" },
                { "label": "Levering af førerkort til ekspeditionssted", "value": this.state.placeOfDispatch ? this.state.placeOfDispatch : "Nej" }
              ]
            }
          ]}
        />

        <Fstyr.Segment
          title="Opret Førerkort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage() }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv CPR"
        >
          <Fstyr.Dropdown
            items={this.state.countries.map(c => c.CountryName).sort()}
            width={300}
            initialValue={this.state.countryInput}
            onItemSelected={(item) => this.setCountryDropdown(item)}
            label="Kørekort udstedt"
            autocomplete={true}
          />

          {
            this.state.driversLicenseType === this.driversLicenseTypes.international &&
            <div className="alert alert-info">
              <div className="alert-body" style={{ marginBottom: 5 }}>
                <p className="alert-heading">Ekstra oplysninger</p>
                <p className="alert-text">Der kræves ekstra oplysninger, da det valgte land ikke er Danmark.</p>
              </div>
              <Fstyr.Input
                value={this.state.driverLicenseNumber}
                label="Kørekortnummer"
                direction="column"
                onChange={(value) => { this.setState({ driverLicenseNumber: value }) }}
                validation={true}
                validationType={ValidationType.driverLicenseInt}
                errorBodyText={"Indtast et gyldigt kørekortnummer. Maks 16 tegn."}
                errorExampleText={"f.eks. 1234-abcd"}
                onEnterPressed={() => { }}
                setValid={(valid) => this.setState({ driverLicenseNumberIsValid: valid })}
                buttonClicked={this.state.driverLicenceButtonPressed}
                onValidatingButtonPressed={() => this.setState({ driverLicenceButtonPressed: true })}
              />

              <Fstyr.Input
                value={this.state.driversLicenseIssuingAuthority}
                label="Udstedende myndighed"
                direction="column"
                onChange={(value) => this.setState({ driversLicenseIssuingAuthority: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesAndNumbersMax35}
                errorBodyText={"Udstedende myndighed er påkrævet og må maksimalt fylde 35 karakterer."}
                errorExampleText={"f.eks. Færdselsstyrelsen"}
                onEnterPressed={() => { }}
                setValid={(valid) => this.setState({ driversLicenseAuthorityIsValid: valid })}
                buttonClicked={this.state.driverLicenceButtonPressed}
                onValidatingButtonPressed={() => this.setState({ driverLicenceButtonPressed: true })}
              />
            </div>
          }

          <Fstyr.Input
            value={this.state.cprInput}
            label="CPR nummer"
            direction={"col"}
            width={300}
            onChange={(value) => { this.setState({ cprInput: value }) }}
            validation={true}
            validationType={ValidationType.cpr}
            errorBodyText={"Forkert format (10 tal)"}
            errorExampleText={"f.eks. 1234567890"}
            onEnterPressed={() => { this.cprSearch() }}
            setValid={(valid) => this.setState({ cprIsValid: valid })}
            buttonClicked={this.state.cprButtonPressed}
            onValidatingButtonPressed={() => this.setState({ cprButtonPressed: true })}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => { this.cprSearch() }}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Førerinformation"
        >
          <div className="row justify-content-center " style={{ paddingBottom: "10px" }}>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <div className="fstyr-attention-box" style={{ height: "100%" }}>
                <p>Personoplysninger</p>
                <Fstyr.Input
                  label="CPR"
                  readonly={true}
                  value={this.state.personVm.Cpr}
                  direction="row"
                />
                <div className={this.showCprStatusWarning() ? "form-group form-error" : ""}>
                  <Fstyr.Input
                    label="Status"
                    readonly={true}
                    value={GetCprStatusName(this.state.personVm.CprStatus)}
                    direction="row"
                  />
                  {this.showCprStatusWarning() && (
                    <span className="form-error-message" id="form-error-error">
                      {`For at bestille et førerkort må status ikke være ${GetCprStatusKode(this.state.personVm.CprStatus)}`}
                    </span>
                  )}
                </div>
                <Fstyr.Input
                  label="Fornavn"
                  readonly={true}
                  value={this.state.personVm.FirstName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Efternavn"
                  readonly={true}
                  value={this.state.personVm.LastName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Adresse"
                  readonly={true}
                  value={formatAddress(this.state.personVm.Address, false)}
                  direction="row"
                  addressRequired={this.state.someBoolean}
                />
              </div>
            </div>

            <div style={{ height: "10px" }} className="col-sm-12 col-md-12 col-lg-12 d-xl-none"></div>


            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <div className="fstyr-attention-box" style={{ height: "100%" }}>
                <p>Kørekortoplysninger</p>

                {this.state.driversLicenseType !== this.driversLicenseTypes.international && this.state.driversLicenseType !== this.driversLicenseTypes.unvalidated &&
                  <Fstyr.Checkbox
                    value={this.state.tempBoxChecked}
                    name="checkbox"
                    label="Midlertidigt kørekort"
                    checked={this.state.driversLicenseType === this.driversLicenseTypes.temporary}
                    onClick={(value) => this.handleTemporaryDriversLicenseCheckbox(value)}
                  />
                }

                {this.state.driversLicenseType === this.driversLicenseTypes.permanent &&
                  <>
                    <Fstyr.Input
                      value={this.state.driverLicenseNumber}
                      label="Kørekort nr."
                      direction="row"
                      type={"number"}
                      onChange={(value) => { this.setState({ driverLicenseNumber: value }) }}
                      validation={true}
                      validationType={ValidationType.driverLicenseDk}
                      errorBodyText={"Forkert format (8 tal)"}
                      errorExampleText={"f.eks. 12345678"}
                      onEnterPressed={() => { this.fetchDriverLicense() }}
                      setValid={(valid) => this.setState({ driverLicenseNumberIsValid: valid })}
                      buttonClicked={this.state.driverLicenceButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ driverLicenceButtonPressed: true })}
                    />

                    < >
                      <Fstyr.Button
                        label="Søg"
                        onClick={() => { this.fetchDriverLicense() }}
                        disabled={this.state.showDriverLicenseSpinner}
                      />
                      <div style={{ width: 20 }} />
                      <Fstyr.Spinner
                        show={this.state.showDriverLicenseSpinner}
                      />
                    </>

                    <Fstyr.Input
                      value={this.state.driverLicenseVm[0].FirstName ?? ""}
                      label="Fornavn"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      value={this.state.driverLicenseVm[0].LastName ?? ""}
                      label="Efternavn"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      value={this.state.driverLicenseVm[0].Birthday ?? ""}
                      label="Fødselsdato"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      value={this.state.driverLicenseVm[0].IssuingAuthority ?? ""}
                      label="Udstedende myndighed"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      value={this.state.driverLicenseVm[0].Categories ?? ""}
                      label="Kategorier (komma separeret)"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      value={((this.state.driverLicenseVm[0].ValidFrom ? DateFormatter(this.state.driverLicenseVm[0].ValidFrom) : "") + (this.state.driverLicenseVm[0].ValidFrom && this.state.driverLicenseVm[0].ValidTo ? " til " : "") + (this.state.driverLicenseVm[0].ValidTo ? DateFormatter(this.state.driverLicenseVm[0].ValidTo) : ""))}
                      label="Gyldighedsperiode (B)"
                      direction="row"
                      readonly={true}
                    />
                    <Fstyr.Input
                      label="Status (B)"
                      readonly={true}
                      value={this.state.driverLicenseVm[0].BStatus}
                      direction="row"
                    />

                  </>
                }
                {this.state.driversLicenseType === this.driversLicenseTypes.unvalidated &&
                  <>
                    <Fstyr.Input
                      value={this.state.driverLicenseNumber}
                      label="Kørekort nr."
                      direction="row"
                      type={"number"}
                      onChange={(value) => { this.setState({ driverLicenseNumber: value }) }}
                      validation={true}
                      validationType={ValidationType.driverLicenseDk}
                      errorBodyText={"Forkert format (8 tal)"}
                      errorExampleText={"f.eks. 12345678"}
                      onEnterPressed={() => { this.fetchDriverLicense() }}
                      setValid={(valid) => this.setState({ driverLicenseNumberIsValid: valid })}
                      buttonClicked={this.state.driverLicenceButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ driverLicenceButtonPressed: true })}
                    />
                    <Fstyr.Dropdown
                      items={["Færdselsstyrelsen", "Rigspolitiet"]}
                      autoSelect={true}
                      onItemSelected={(value) => this.setState({ driversLicenseIssuingAuthority: value })}
                      label="Udstedende myndighed"
                      direction="row"
                    />
                    <div className="alert alert-info">
                      <div className="alert-body">
                        <p className="alert-heading">OBS: Ingen validering</p>
                        <p className="alert-text">Du har slået validering af kørekortnummeret fra, for at slå det til igen skal du rydde siden.</p>
                      </div>
                    </div>
                  </>
                }
                {this.state.driversLicenseType === this.driversLicenseTypes.temporary &&
                  <>
                    <Fstyr.Input
                      value={this.state.driverLicenseNumber}
                      label="Kørekort nr."
                      direction="row"
                      type={"number"}
                      onChange={(value) => { this.setState({ driverLicenseNumber: value }) }}
                      validation={true}
                      validationType={ValidationType.driverLicenseDk}
                      errorBodyText={"Forkert format (8 tal)"}
                      errorExampleText={"f.eks. 12345678"}
                      onEnterPressed={() => { this.fetchDriverLicense() }}
                      setValid={(valid) => this.setState({ driverLicenseNumberIsValid: valid })}
                      buttonClicked={this.state.driverLicenceButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ driverLicenceButtonPressed: true })}
                    />
                    < >
                      <Fstyr.Button
                        label="Kontrollér"
                        onClick={() => this.fetchDriverLicense()}
                        disabled={this.state.showDriverLicenseSpinner}
                      />
                      <div style={{ width: 20 }} />
                      <Fstyr.Spinner
                        show={this.state.showDriverLicenseSpinner}
                      />
                    </>
                    <Fstyr.Input
                      value={this.state.driversLicenseIssuingAuthority}
                      label="Udstedende myndighed"
                      direction="row"
                      onChange={(value) => this.setState({ driversLicenseIssuingAuthority: value })}
                      validation={true}
                      validationType={ValidationType.textWithSpacesAndNumbersMax35}
                      errorBodyText={"Udstedende myndighed er påkrævet og må maksimalt fylde 35 karakterer."}
                      errorExampleText={"f.eks. Færdselsstyrelsen"}
                      onEnterPressed={() => { }}
                      setValid={(valid) => this.setState({ driversLicenseAuthorityIsValid: valid })}
                      buttonClicked={this.state.orderButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                    />

                    <Fstyr.Input
                      label="Bemærkning"
                      onChange={(value) => this.setState({ remark: value })}
                      value={this.state.remark}
                      direction="row"
                      validation={true}
                      validationType={ValidationType.textWithSpacesAndNumbers}
                      errorBodyText={"Bemærkning mangler."}
                      errorExampleText={"f.eks. Midlertidigt kørekort forevist."}
                      onEnterPressed={() => { }}
                      setValid={(valid) => this.setState({ driverLicenseRemarkIsValid: valid })}
                      buttonClicked={this.state.orderButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                    />
                    <Fstyr.Input
                      label="Kørekort fundet"
                      readonly={true}
                      value={this.state.driverLicenseVm[0].ResponseStatus ? this.state.driverLicenseVm[0].ResponseStatus === "NotFound" ? "Nej" : this.state.driverLicenseVm[0].ResponseStatus === "Found" ? "Ja" : "Uvidst" : ""}
                      direction="row"
                    />
                  </>}


                {this.state.driversLicenseType === this.driversLicenseTypes.international &&
                  <>
                    <Fstyr.Input
                      value={this.state.driverLicenseNumber}
                      label="Kørekort nr."
                      direction="row"
                      readonly={true}
                    />

                    <Fstyr.Input
                      value={this.state.driversLicenseIssuingAuthority}
                      label="Udstedende myndighed"
                      direction="row"
                      readonly={true}
                    />

                    <Fstyr.Input
                      label="Bemærkning"
                      onChange={(value) => this.setState({ remark: value })}
                      value={this.state.remark}
                      direction="row"
                      validation={true}
                      validationType={ValidationType.textWithSpacesAndNumbers}
                      errorBodyText={"Bemærkning mangler."}
                      errorExampleText={"f.eks. Udenlandsk kørekort."}
                      onEnterPressed={() => { }}
                      setValid={(valid) => this.setState({ driverLicenseRemarkIsValid: valid })}
                      buttonClicked={this.state.orderButtonPressed}
                      onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                    />
                  </>}
              </div>
            </div>
          </div>

          <div >
            <Fstyr.SelectableTable
              label="Danske resultater"
              headers={["Førerkortnr.", "Kørekortnr.", "Startdato", "Udløbsdato", "Status", "Bemærkning"]}
              data={this.state.dkTableResults}
              note={"Ansøger har " + this.state.dkTableResults.length + " registreringer på førerkort"}
              path={"driverCard"}
              preSelect={true}
              tableName="danishResultsTable"
              disableAll={true}
              useLinks={true}
            />
            <Fstyr.SelectableTable
              label="EU resultater"
              headers={["Førerkortnr.", "Fornavn", "Efternavn", "Land", "Kørekortnr.", "Startdato", "Udløbsdato", "Status"]}
              data={this.state.euTableResults}
              note={"Ansøger har " + this.state.euTableResults.length + " registreringer på førerkort i EU"}
              path={"driverCard"}
              tableName="euResultsTable"
              disableAll={true}
              useLinks={false}
            />
            <div className="alert alert-info">
              <div className="alert-body">
                <p className="alert-heading">EU svar</p>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.Found}</p>
                  <p className="alert-text">Found</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotFound}</p>
                  <p className="alert-text">NotFound</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotAvailable}</p>
                  <p className="alert-text">NotAvailable</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.TimeOut}</p>
                  <p className="alert-text">Timeout</p>
                </div>
              </div>
            </div>
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Billede"
        >
          <div className={((!this.state.pictureChosen && this.state.orderButtonPressed) || this.state.pictureTooBig) ? "form-group form-error" : ""}>
            <ImageCrop
              onCut={(value) => this.setImageBase64(value)}
              showComponent={this.state.showImageCropper}
              setShowComponent={(value) => this.setShowImageCropper(value)}
            />
            {(!this.state.pictureChosen && this.state.orderButtonPressed) &&
              <span className="form-error-message" id="form-error-error">
                {"Et billede skal vælges og beskæres"}
              </span>
            }
            {(this.state.pictureTooBig) &&
              <span className="form-error-message" id="form-error-error">
                {"Billedet er for stort, prøv at beskære billedet anderledes."}
              </span>
            }
          </div>

        </Fstyr.Segment>
        <Fstyr.Segment
          title="Bestilling"
        >
          <div>
            <Fstyr.RadioButtonGroup
              label="Angiv type af bestilling"
              choices={this.getRadiobuttons()}
              value={this.state.orderType}
              onClick={(value) => this.setState({ orderType: value })}
            />
            {/*Status på tidligere kort*/}
            <div className={(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) ? "form-group form-error" : ""}>

              {(this.state.orderType === this.orderTypes.fornyelse || this.state.orderType === this.orderTypes.udskiftning) &&
                <Fstyr.Dropdown
                  items={filterCardStatusesRenewed(require('../../assets/CardStatus.json'))}
                  width={320}
                  onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                  label="Status på tidligere kort"
                  direction="col"
                />
              }
              {(this.state.orderType === this.orderTypes.erstatning) &&
                <Fstyr.Dropdown
                  items={filterCardStatusesReplaced(require('../../assets/CardStatus.json'))}
                  width={320}
                  onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                  label="Status på tidligere kort"
                  direction="col"
                />
              }

              {(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) && (
                <span className="form-error-message" id="form-error-error">
                  {"Status skal udfyldes"}
                </span>
              )}
            </div>


            <p className="fstyr-text-header">Leveringsinformation</p>
            <Fstyr.Checkbox
              label="Ekspreslevering"
              checked={this.state.expressDelivery}
              onClick={(value) => {
                this.setState({ expressDelivery: value })
              }}
            />
            <Fstyr.Checkbox
              label="Levering af førerkort til ekspeditionssted"
              checked={this.state.deliveryToPlaceOfDispatch || this.state.deliveryToPlaceOfDispatchRequired}
              onClick={(value) => {
                this.setState({ deliveryToPlaceOfDispatch: value })
              }}
              disabled={this.state.deliveryToPlaceOfDispatchRequired}
            />
            {(this.state.deliveryToPlaceOfDispatch || this.state.deliveryToPlaceOfDispatchRequired) && (
              <div className={(this.state.orderButtonPressed && !this.state.placeOfDispatch) ? "form-group form-error" : ""}>
                <Fstyr.Dropdown
                  items={["2001 - København", "2002 - Kolding", "2003 - Aalborg"]}
                  width={300}
                  onItemSelected={(value) => this.setState({ placeOfDispatch: value })}
                  label="Lokation"
                />
                {(this.state.orderButtonPressed && !this.state.placeOfDispatch) && (
                  <span className="form-error-message" id="form-error-error">
                    {"Lokation skal udfyldes"}
                  </span>
                )}
              </div>
            )}

            {nameTooLong(this.state.personVm.FirstName) &&
              <Fstyr.Input
                value={this.state.firstNameOnCard}
                direction='column'
                label="Fornavn på kort"
                onChange={(value) => this.setState({ firstNameOnCard: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesMax35}
                setValid={(valid) => this.setState({ firstNameOnCardIsValid: valid })}
                buttonClicked={true} //set to true to ensure that validation always activated
                onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                errorBodyText={"Personens fornavn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn."}
                errorExampleText={"f.eks. Anna B. C."}
              />
            }
            {nameTooLong(this.state.personVm.LastName) &&
              <Fstyr.Input
                value={this.state.lastNameOnCard}
                direction='column'
                label="Efternavn på kort"
                onChange={(value) => this.setState({ lastNameOnCard: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesMax35}
                setValid={(valid) => this.setState({ lastNameOnCardIsValid: valid })}
                buttonClicked={true} //set to true to ensure that validation always activated
                onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                errorBodyText={"Personens efternavn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn."}
                errorExampleText={"f.eks. A. B. Carlsen"}
              />
            }
          </div>
        </Fstyr.Segment >
        <Fstyr.Segment
          title="Bestillingsinformation"
        >
          <Fstyr.Button
            label="Se bestilling"
            onClick={() => this.validateOrder()}
          />
        </Fstyr.Segment>
        <Fstyr.Segment
          title=""
          isPageTitle={true}
        />
      </ >
    );
  }
}
    //#endregion

